import Scriba from 'react-scriba';

export class DataAlarme {

    static _chargementAlarmes = (filtres, sortedColumn, isSortedDescending) => {
        const objet = { filtres, sortedColumn, isSortedDescending };
        const url = "api/Liste/ListeDesAlarmes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementAlarme = (alarme) => {
        const url = "api/MAJDonnees/EnregistrementAlarme";
        const paramPost = Scriba.fetch().createParameterPost(alarme);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onDesactivationAlarmes = (idsAlarmes) => {
        const objet = { idsAlarmes };
        const url = "api/MAJDonnees/DesactivationAlarmes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionAlarme = (idAlarme) => {
        const objet = { idAlarme };
        const url = "api/MAJDonnees/SuppressionAlarme";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionAlarmes = (idsAlarmes) => {
        const objet = { idsAlarmes };
        const url = "api/MAJDonnees/SuppressionAlarmes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _chargementNombreAlarmesAVenir() {

        var url = "api/TableauDeBord/GetNombreAlarmesAVenir";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementNombreSouhaitsParDernierSuiviCommercial() {

        var url = "api/TableauDeBord/GetNombreSouhaitsParDernierSuiviCommercial";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementNombreOperationsParPhaseAvancement() {

        var url = "api/TableauDeBord/GetNombreOperationsParPhaseAvancement";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementQueuesDeProgrammes() {

        var url = "api/TableauDeBord/GetQueuesDeProgrammes";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementNombreSouhaitsParRDV() {

        var url = "api/TableauDeBord/GetNombreSouhaitsParRDV";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementNombreSouhaitsParSuiviCommercial() {

        var url = "api/TableauDeBord/GetNombreSouhaitsParSuiviCommercial";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementNombreContratsParEtatSignature() {

        var url = "api/TableauDeBord/GetNombreContratsParEtatSignature";
        var paramPost = Scriba.fetch().createParameterPost();

        return fetch(url, paramPost).then(response => response.json());
    }

}
